import request from '@/utils/request'


// 查询举报原因列表
export function listCommunityReportReason(query) {
  return request({
    url: '/community/admin/report/reason/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询举报原因分页
export function pageCommunityReportReason(query) {
  return request({
    url: '/community/admin/report/reason/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询举报原因详细
export function getCommunityReportReason(data) {
  return request({
    url: '/community/admin/report/reason/detail',
    method: 'get',
    params: data
  })
}

// 新增举报原因
export function addCommunityReportReason(data) {
  return request({
    url: '/community/admin/report/reason/add',
    method: 'post',
    data: data
  })
}

// 修改举报原因
export function updateCommunityReportReason(data) {
  return request({
    url: '/community/admin/report/reason/edit',
    method: 'post',
    data: data
  })
}

// 删除举报原因
export function delCommunityReportReason(data) {
  return request({
    url: '/community/admin/report/reason/delete',
    method: 'post',
    data: data
  })
}
